import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'libphonenumber-js';

@Pipe({
    name: 'phoneFormatPipe',

})
export class phoneFormatPipe implements PipeTransform {
    transform(value: string, code: any) {
        if (code) {
            value = format(value, code, 'International');
            return value;
        } else {
            return null;
        }
    }
}